import { render, staticRenderFns } from "./GraphSetting.vue?vue&type=template&id=04df8511&scoped=true"
import script from "./GraphSetting.vue?vue&type=script&lang=ts"
export * from "./GraphSetting.vue?vue&type=script&lang=ts"
import style0 from "./GraphSetting.vue?vue&type=style&index=0&id=04df8511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df8511",
  null
  
)

export default component.exports